module.exports = __webpack_public_path__ + "7d2916d1104521e90d0ba0959def3a34.png";